// extracted by mini-css-extract-plugin
export default {"result_line_block":"ResultLine_result_line_block__StDYR"};